<template>
  <div>
    
    <ContentsHeader>
      <template v-slot:title01>{{jobName}}</template>
      <template v-slot:explain01>
          人材採用に投資を行う企業と働き口を探す人材の橋渡しを担う存在が人材業界の営業職です。企業が求める人材を採用できるようにコンサルティングを行う一方で、求職者に対しキャリア相談や研修をおこないます。正規/非正規雇用を問わず、企業と求職者をマッチングさせるためのプロとして、ときには入社前の研修や入社後のフォローまでおこなう場合もあります。売り手市場とは言われ、企業が優秀な人材獲得に四苦八苦しているこの業界の営業職にはどのような傾向が見られるのでしょうか。 
      </template>
      <template v-slot:yarigai01><span class="ddin">貴方からの紹介だから採用しますという言葉を聞いたとき</span><span class="ddin">(福岡県 31歳 女性)</span></template>
      <template v-slot:yarigai02><span class="ddin">客先に伺った際、いきいきと働いている人に出会えます</span><span class="ddin">(神奈川県 36歳 女性)</span></template>
      <template v-slot:yarigai03><span class="ddin">採用人材が直接雇用となり企業と人材ともに貢献できたこと</span><span class="ddin">(福岡県 54歳 男性)</span></template>
      <template v-slot:img-headbg><img src="../assets/img/staffagency/headbg.svg" :alt="jobName" class="img -staffagency"></template>
      <template v-slot:img-headp><img src="../assets/img/staffagency/person.svg" :alt="jobName" class="imgp -staffagency"></template>
    </ContentsHeader>

    <div class="contents-block">

      <section class="job-section">
        <div class="jsinner">
          <div class="block-two -aistretch -jcsb -bptablet">
            <div class="block -b48p -p0">
              <BalanceChartSection :explain="bcExplain" :radarData="radarData"></BalanceChartSection>
            </div>
            <div class="block -b48p -p0">
              <JobChangeRateSection
                :explain="jcExplain"
                :doughnutData="doughnutData"
                :doughnutDataFake="doughnutData"
              ></JobChangeRateSection>
            </div><!-- .block -->
          </div><!-- .block-two -->
        </div><!-- .jsinner -->
      </section>

      <PersonalCharaSection :sevenData="sevenData" :secTtl="'人材業界'" >
        <template v-slot:feature>自信を持ちつつ<br>慎重に考えるゼネラリスト</template>
        <template v-slot:imgpup><img src="../assets/img/staffagency/person.svg" alt="人材業界のセールスパーソン特徴" class="imgcvperson -staffagency"></template>
      </PersonalCharaSection>
    
      <div class="lb-area">
        <div class="lbinner block-two -bptablet">
          <div class="block">
            <CareerTypeSection :graphData="graphData" :explain="ctExplain" :jobName="'人材'"></CareerTypeSection>
          </div><!-- .block -->
          <div class=" block">
            <SalesTypeSection :graph2Data="graph2Data" :explain="stExplain" :jobName="'人材'"></SalesTypeSection>
          </div><!-- .block -->
        </div><!-- .block-two -->
      </div><!-- .lb-area -->

      <ResultSection :job="'staffagency'">
        <template v-slot:jobname>人材業界のセールスパーソン</template>
        <template v-slot:title01>慎重な判断と自信を持った提案</template>
        <template v-slot:explain01>
          慎重で自信家な傾向にあることが分かります。
          <br />人材業界では、仲介役となって企業と求職者を紹介し、それぞれに踏み込んで対話しサポートする必要があるため、それぞを引き合わせる押しの強さや、お互いがマッチしているかを慎重に見極める能力が重要であるといえます。
        </template>
        <template v-slot:title02>情報感度の高いゼネラリスト</template>
        <template v-slot:explain02>
          外向的でゼネラリスト志向な傾向にあることが分かります。
          <br />幅広い業界について、企業求める人物像を特性や経験、スキルといった具体的な言語に落とし込んでいく必要があります。様々な業界の知識を身に付けるための好奇心や、総合的な判断ができる知見が求められていると言えそうです。
        </template>
        <template v-slot:imgperson><img src="../assets/img/staffagency/person.svg" alt="人材業界のセールスパーソン" class="rsimg"></template>
      </ResultSection>

      <section class="other-section">
        <h2 class="osttl">その他の業界ごとの詳細をのぞく</h2>
        <div class="osinner">
          <DetailsList :job="'staffagency'"></DetailsList>
        </div><!-- .osinner -->
      </section>

    </div>

  </div>
</template>

<script>
import ContentsHeader from "../components/ContentsHeader.vue";
import ResultSection from "../components/ResultSection.vue";
import DetailsList from "../components/DetailsList.vue";

import BalanceChartSection from "../components/BalanceChartSection.vue";
import JobChangeRateSection from "../components/JobChangeRateSection.vue";
import PersonalCharaSection from "../components/PersonalCharaSection.vue";
import CareerTypeSection from "../components/CareerTypeSection.vue";
import SalesTypeSection from "../components/SalesTypeSection.vue";

export default {
  data() {
    return {
      pageTitle: "人材の営業をのぞく",
      pageURL: "staffagency",
      pageDescription: "SALES SCOPEでは不動産、保険、ITなど人気10業界の営業職に人物特性と成績に関する調査を実施。人材採用に投資を行う企業と働き口を探す人材の橋渡しを担う存在が人材業界の営業職です。企業が優秀な人材獲得に四苦八苦しているこの業界の営業職にはどのような傾向が見られるのでしょうか。",

      jobName: "人材の営業",
      bcExplain: "挑戦意欲に長けておりバランスも良い",
      jcExplain: "転職回数はやや多め",
      pcExplain: "自信を持ちつつ慎重に考えるゼネラリスト",
      ctExplain:
        "安定・保障された身分と社会貢献をのぞむタイプが多く、困難な課題の解決をのぞむチャレンジャータイプは少ない",
      stExplain:
        "戦略的思考に沿って行動し、顧客と親密な関係を築こうとするタイプが多い",
      radarData: [6.71, 6.71, 6.31, 6.89, 8.26],
      doughnutData: [24, 28, 28, 4, 16],
      sevenData: [5, 2, 5, 4, 4, 5, 3],
      graphData: [
        { num: 1, val: 8 },
        { num: 2, val: 12 },
        { num: 3, val: 8 },
        { num: 4, val: 24 },
        { num: 5, val: 8 },
        { num: 6, val: 20 },
        { num: 7, val: 4 },
        { num: 8, val: 16 },
      ],
      graph2Data: [
        { num: 1, val: 12 },
        { num: 2, val: 28 },
        { num: 3, val: 20 },
        { num: 4, val: 32 },
        { num: 5, val: 8 },
      ],

    };
  },
  components: {
    BalanceChartSection,
    JobChangeRateSection,
    PersonalCharaSection,
    CareerTypeSection,
    SalesTypeSection,
    ContentsHeader,
    ResultSection,
    DetailsList
  },
  metaInfo: {
    title: "人材の営業をのぞく | 営業職の特徴を人物特性からのぞいてみた",
    titleTemplate: "%s | SALES SCOPE",
    htmlAttrs: {
      lang: "jp",
    },
    // meta: [
    //   {
    //     name: "description",
    //     content: this.pageDescription,
    //   },    
    // ],
  },
  mounted: function(){
    // document.title = title;
    document.querySelector("meta[name='description']").setAttribute('content', this.pageDescription);
    document.querySelector("meta[property='og:title']").setAttribute('content', this.pageTitle + " | 営業職の特徴を人物特性からのぞいてみた | SALES SCOPE");
    document.querySelector("meta[property='og:description']").setAttribute('content', this.pageDescription);
    document.querySelector("meta[property='og:url']").setAttribute('content', 'https://sales-score.jp/scope/' + this.pageURL);
  }
}
</script>